import { DRIVSTOFFTYPE, ENHETSTYPE, REGULERING_I_GANGFELT, REGULERING_I_VEGKRYSS } from './Konstanter'

export const NYE_ENHETSTYPER = [12, 16, 17, 18, 21, 22, 23, 25, 26, 41, 43, 44, 50, 51, 55, 56, 61, 67]
export const ENDREDE_ENHETSTYPER = [5, 10, 13, 35, 42, 45, 52, 57]
export const NYE_FELTER = [DRIVSTOFFTYPE, REGULERING_I_GANGFELT, REGULERING_I_VEGKRYSS]
export const ENDREDE_FELTER = [ENHETSTYPE]
